import { localConstants } from '../_constants';

export const localeActions = {
  changeLocale,

};

function changeLocale(locale) {
  return { type: localConstants.CHANGE_LOCALE_LANGUAGE_SUCCESS, locale };
}